import React from 'react'
import { WidgetGuard } from 'features/types'
import {
  TopicInaccessibleGuard,
  TopicIndexNotReadyGuard,
  UnexpectedServiceErrorGuard
} from '../../share/guards'
import LanguageNotSupportedGuard from './LanguageNotSupportedGuard'
import LanguageNotSupportedOrNoDataReturnedGuard from './LanguageNotSupportedOrNoDataReturnedGuard'
import NoDataReturnedGuard from './NoDataReturnedGuard'

const BrandPassionIndexWidgetDataGuards: WidgetGuard = ({ widgetId, children }) => (
  <TopicInaccessibleGuard widgetId={widgetId}>
    <UnexpectedServiceErrorGuard widgetId={widgetId}>
      <TopicIndexNotReadyGuard widgetId={widgetId}>
        <LanguageNotSupportedGuard widgetId={widgetId}>
          <NoDataReturnedGuard widgetId={widgetId}>
            <LanguageNotSupportedOrNoDataReturnedGuard widgetId={widgetId}>
              {children}
            </LanguageNotSupportedOrNoDataReturnedGuard>
          </NoDataReturnedGuard>
        </LanguageNotSupportedGuard>
      </TopicIndexNotReadyGuard>
    </UnexpectedServiceErrorGuard>
  </TopicInaccessibleGuard>
)

export default BrandPassionIndexWidgetDataGuards
